import { useState, useEffect } from "react"
import { apiRequest } from "../utils/apiRequest"

// Module-level cache so the published-post count is fetched once and shared by every
// consumer (Header + Footer), rather than once per component mount.
let cachedPromise = null

const fetchHasBlogPosts = () => {
  if (!cachedPromise) {
    cachedPromise = apiRequest({
      method: "get",
      url: "/blog?limit=1&page=1",
      suppressNotifications: true,
    })
      .then((res) => {
        const body = res.data || res
        return (body.pagination?.total || 0) > 0
      })
      .catch(() => {
        // Don't poison the cache on a transient failure — let the next mount retry.
        cachedPromise = null
        return false
      })
  }
  return cachedPromise
}

/**
 * Returns whether there is at least one published blog post. Defaults to `false`
 * while loading so the Blog menu stays hidden until we know posts exist (avoids a
 * flash of a Blog link that leads to an empty page).
 */
export const useBlogAvailability = () => {
  const [hasBlogPosts, setHasBlogPosts] = useState(false)

  useEffect(() => {
    let active = true
    fetchHasBlogPosts().then((has) => {
      if (active) setHasBlogPosts(has)
    })
    return () => {
      active = false
    }
  }, [])

  return hasBlogPosts
}

export default useBlogAvailability
